import React from "react";

import "./style.css";

import {
    MainContentPlayerProps,
    MainContentPlayerState
} from "./models";

import {
    Box,
    Grid,
    Typography
} from "@mui/material";
import { ThumbnailPlayer } from "./thumbnail-player/thumbnail-player";
import { selectDescriptionByLanguage } from "utils";


export class MainContentPlayer extends React.Component<MainContentPlayerProps, MainContentPlayerState> {

    render() {

        return (<>
            {process.env.REACT_APP_MAIN_CONTENT_PLAYER_TYPE === "HALF_INFO" && <Box sx={{ px: 5, py: 2 }} className={"mcp-main"}>
                <Grid container sx={{ mb: 3 }}>
                    <Grid item xs={12} lg={7} className="grid-player">
                        <ThumbnailPlayer content={this.props.content} />
                    </Grid>
                    <Grid item xs={12} lg={5} className="grid-content">
                        <Typography className="content-title" variant={"h2"}>{selectDescriptionByLanguage(this.props.content!.title, this.props.content!.language)}</Typography>
                        <Typography variant={"body1"}
                            sx={{ color: "white" }}>{selectDescriptionByLanguage(this.props.content!.synopsis, this.props.content!.language)}</Typography>
                    </Grid>
                </Grid>
            </Box>}
            {process.env.REACT_APP_MAIN_CONTENT_PLAYER_TYPE === "FULL_WIDTH" && <Box sx={{ w: 100 }}>
                <ThumbnailPlayer content={this.props.content} />
            </Box>}
            {process.env.REACT_APP_MAIN_CONTENT_PLAYER_TYPE === "FULL_W_AND_INFO" && <Box sx={{ w: 100 }}>
                <Box sx={{
                    position: "absolute",
                    zIndex: 999,
                }}>
                    <Typography variant={"h1"} style={{
                        color: process.env.REACT_APP_PRIMARY_COLOR
                    }}>
                        {selectDescriptionByLanguage(this.props.content!.title, this.props.content!.language)}
                    </Typography>

                    <Typography variant={"body1"} style={{
                        color: process.env.REACT_APP_SECONDARY_COLOR
                    }}>
                        {selectDescriptionByLanguage(this.props.content!.synopsis, this.props.content!.language)}
                    </Typography>
                </Box>
                <ThumbnailPlayer content={this.props.content} />
            </Box>}
        </>);
    }
}
